import { render } from "./Tablet.vue?vue&type=template&id=b58cdc18"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Tablet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b58cdc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b58cdc18', __exports__)) {
    api.reload('b58cdc18', __exports__)
  }
  
  module.hot.accept("./Tablet.vue?vue&type=template&id=b58cdc18", () => {
    api.rerender('b58cdc18', render)
  })

}


export default __exports__